export const calculateAreaPrice = (area, price) => {
  const areaPrice = area * price;
  return areaPrice;
};

export const isAreaInRange = (area, range) => {
  const { min_ha, max_ha } = range;

  if (max_ha !== undefined) {
    return area >= min_ha && area <= max_ha;
  }

  return area >= min_ha;
};
export const totals = {
  area: (properties) =>
    properties?.reduce((total, property) => total + (property?.area ?? 0), 0) || 0,

  forestArea: (properties) =>
    properties?.reduce((total, property) => total + (property?.forestArea ?? 0), 0) || 0
};

export const mapPropertiesData = (properties) => {
  return properties.map((prop) => {
    const forestLand = prop?.forest_land ?? prop?.data?.forest_land;
    const disabled =
      prop.type !== 'PROP' ||
      ['broken', 'running'].includes(prop?.status) ||
      prop?.data?.overview_classification?.forest_land === 0 ||
      forestLand === 0;

    const isShared = prop?.role ? prop.role !== 'owner' : Boolean(prop?.is_shared);

    const designation = disabled
      ? `${prop.designation} - Inte tillgänglig`
      : isShared
        ? `${prop.designation} - Delad med dig`
        : prop.designation;

    return {
      designation,
      ref: prop.ref,
      isShared,
      // Drone: area from prop or prop.data
      area: prop?.area ?? prop?.data?.area,
      // Subscription: forest area and pricing fields
      forestArea: forestLand ?? 0,
      plus_price_error: prop?.plus_price_error ?? prop?.data?.plus_price_error ?? 0,
      plus_price: prop?.plus_price ?? prop?.data?.plus_price ?? 0,
      plus_price_max: prop?.plus_price_max ?? prop?.data?.plus_price_max ?? 0,
      type: prop.type,
      lmID: prop?.lmID ?? null,
      dfr: prop?.dfr ?? false,
      hasBadData: prop?.has_bad_data ?? false,
      disabled
    };
  });
};
